module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('f7-statusbar'), _vm._v(" "), _c('f7-views', [_c('f7-view', {
    attrs: {
      "color-theme": "blue",
      "id": "main-view",
      "navbar-through": "",
      "dynamic-navbar": true,
      "main": ""
    }
  }, [_c('f7-page', {
    attrs: {
      "color-theme": "blue"
    }
  }, [_c('f7-navbar', [_c('f7-nav-title', [_vm._v("Busquemos")])], 1), _vm._v(" "), _c('f7-messages', {
    attrs: {
      "color-theme": "blue"
    }
  }, [_c('p', {
    staticClass: "messages-title"
  }, [_vm._v(_vm._s(_vm.now))]), _vm._v(" "), _vm._l((_vm.messages), function(message, i) {
    return _c('div', {
      key: ("k-" + i),
      staticClass: "messages-message"
    }, [(!message.image) ? _c('f7-message', {
      class: _vm.getType(message.uid),
      attrs: {
        "text": message.text,
        "label": message.label,
        "color": _vm.getType(message.uid) === 'sent' ? 'blue' : '',
        "date": message.date,
        "name": message.index === 0 ? message.name : '',
        "avatar": message.avatar,
        "image": message.image,
        "type": _vm.getType(message.uid),
        "day": message.day,
        "first": message.first,
        "last": message.last,
        "tail": message.last,
        "time": message.time
      },
      on: {
        "click": _vm.onClick,
        "click:text": _vm.onTextClick,
        "click:name": _vm.onNameClick,
        "click:avatar": _vm.onAvatarClick
      }
    }, [_c('div', {
      staticClass: "msg",
      attrs: {
        "slot": "text"
      },
      domProps: {
        "innerHTML": _vm._s(message.text)
      },
      slot: "text"
    }), _vm._v(" "), _c('div', {
      staticClass: "message-date",
      attrs: {
        "slot": "bubble-end"
      },
      slot: "bubble-end"
    }, [_vm._v("\n                " + _vm._s(message.date) + "\n              ")])]) : _vm._e(), _vm._v(" "), (message.image) ? _c('div', {
      staticClass: "message message-received received message-appear-from-bottom",
      class: {
        'message-tail': message.last,
        'message-last': message.last
      }
    }, [_c('div', {
      staticClass: "message-avatar",
      staticStyle: {
        "background-image": "url('https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg')"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-bubble messages-image"
    }, [_c('a', {
      staticClass: "external",
      attrs: {
        "target": "_blank",
        "rel": "noopener noreferrer",
        "href": message.image
      }
    }, [_c('img', {
      attrs: {
        "loading": "lazy",
        "src": message.image,
        "alt": message.text
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "message-date"
    }, [_vm._v("\n                  " + _vm._s(message.date) + "\n                ")])])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.options.length > 0) ? _c('div', {
    staticClass: "messages-message opt-wrapper"
  }, _vm._l((_vm.options), function(opt) {
    return _c('button', {
      key: opt.text,
      staticClass: "question-opts message message-received received message-appear-from-bottom",
      on: {
        "click": function($event) {
          return _vm.onSubmit({
            text: opt.text,
            callback: opt.callback_data
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(opt.text) + "\n            ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('f7-message', {
    attrs: {
      "type": "received",
      "typing": true,
      "first": true,
      "last": true,
      "tail": true,
      "header": "Busquemos está escribiendo...",
      "avatar": "https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('f7-messagebar', {
    ref: "messagebar",
    attrs: {
      "placeholder": "Mensaje",
      "send-link": "Enviar"
    },
    on: {
      "submit": _vm.onSubmit
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeyEnter.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6d3d67c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 157
// module chunks = 1